export default __webpack_public_path__ + "static/media/filter-status-close.f736c63d.svg";